import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { LighthouseTicketService } from "../../models/integrations/lighthouse-ticket.service";

@Component({
  selector: "ab-lighthouse-integration",
  templateUrl: "./lighthouse.component.html",
})
export class LighthouseIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public ticket: any;
  public creatingTicket: boolean;
  public error: any;
  public removingTicket: boolean;

  constructor(private lighthouseTicketService: LighthouseTicketService) {}

  public ngOnInit() {
    this.loading = true;

    return this.lighthouseTicketService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((ticket: any) => {
        this.ticket = ticket;
      });
  }

  public createTicket() {
    this.ticket = { notice: this.notice };

    this.creatingTicket = true;
    return this.lighthouseTicketService
      .create(this.ticket)
      .pipe(
        finalize(() => {
          delete this.creatingTicket;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeTicket() {
    this.ticket = { notice: this.notice };

    this.removingTicket = true;
    return this.lighthouseTicketService
      .destroy(this.ticket)
      .pipe(
        finalize(() => {
          delete this.removingTicket;
        }),
      )
      .subscribe(() => {
        delete this.ticket;
      });
  }
}
